<template>
	<section class="container">
		<div class="marketing-section py-400-md">
			<h2 class="heading-5">Historical performance<sup>1</sup></h2>
			<dl class="col-6-md my-150">
				<div class="display-flex justify-content-space-between">
					<dt> Trailing 1-year cumulative return through Dec 31, 2024 </dt>
					<dd> 8.30% </dd>
				</div>

				<div class="display-flex justify-content-space-between mt-100">
					<dt> Cumulative return since inception </dt>
					<dd> 22.34% </dd>
				</div>
			</dl>
			<ol class="text-color-content-tertiary ol body-sm">
				<li
					>These return figures represent the total return for the period indicated, including both
					distributions earned and change in share value, and assumes that all distributions are reinvested.
					This performance information represents past performance. Past performance does not guarantee future
					results. The investment return and principal value of an investor's investment will fluctuate so
					that such shares, when redeemed, may be worth more or less than their original cost.</li
				>
			</ol>
		</div>
	</section>
</template>

<style lang="scss" scoped>
@use '../../../styles/constants/_colors.scss' as *;

.marketing-section {
	border-top: 1px solid gray(30);
}
</style>
